import { __read, __spread } from "tslib";
export var classifyColumnData = function (columnName, data) {
    var dataTypes = {};
    var specifyDataType = function (type) {
        if (dataTypes[type])
            dataTypes[type] = dataTypes[type] + 1;
        else
            dataTypes[type] = 1;
    };
    data
        .map(function (rowProperties) { return rowProperties[columnName]; })
        .forEach(function (value) {
        if (typeof value === 'string' && Date.parse(value))
            specifyDataType('datetime');
        if (value !== null)
            specifyDataType(typeof value);
    });
    var maximumOccurencies = Math.max.apply(Math, __spread(Object.values(dataTypes)));
    var _a = __read(Object.keys(dataTypes).filter(function (keyName) {
        return dataTypes[keyName] === maximumOccurencies;
    }), 1), dataType = _a[0];
    if (dataType)
        return dataType;
    return null;
};
